// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"74e61e4b","453":"d0243e00","732":"c2477444","977":"f9fbdf08"}[chunkId] + ".chunk.js";
};